export interface RegionWarning {
    region: CardRegion;
    warningMessage: string;
}

export interface CardRegion {
    id: string;
    name: string;
}

export interface RegionRule {
    enabled: boolean;
    region: CardRegion;
}

export interface CardRule {
    ecommerce: boolean;
    regions: RegionRule[];
}

export interface SiteCoreDictionary {
    [value: string]: string;
}

interface PiwikTag {
    dataTrackId: string;
    dataTrackLinkname: string;
}

interface PiwikTags {
    [value: string]: PiwikTag;
}

export interface Piwik {
    [value: string]: PiwikTags;
}

export const enum AgeGroup {
    CHILD = 'CHILD',
    TEENAGER = 'TEENAGER',
    ADULT = 'ADULT',
}

export interface EcommerceInfo {
    cardOwnerAgeGroup: AgeGroup;
}

export interface AccessInfo {
    userAgeGroup: AgeGroup;
    userIsHighFraudRisk?: boolean;
    infoToIncludeEcommerce?: EcommerceInfo;
}

export interface CardControlLoader {
    isFetchingCardControl: boolean;
    hasFetchedCardControl: boolean;
    failedFetchingCardControl: boolean;
    isPostingCardControl: boolean;
    hasPostedCardControl: boolean;
    failedPostingCardControl: boolean;
}
